import {
  UrgentCareCheckInPayload,
  UrgentCareCheckInResponse,
} from 'pages/pet-owner-dashboard/urgent-care/types';
import {
  CheckInListingParams,
  CheckInListingResponse,
} from 'pages/pet-owner-dashboard/urgent-care/view-status/types';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const submitUrgentCareCheckIn = (payload: UrgentCareCheckInPayload) =>
  apiLoaderInstance.post<UrgentCareCheckInResponse>(
    URL.URGENT_CARE_CHECK_IN,
    payload
  );

export const getCheckInListing = (params: CheckInListingParams) =>
  apiLoaderInstance.get<CheckInListingResponse>(
    URL.URGENT_CARE_CHECKIN_LISTING,
    { params }
  );
